import React from 'react';
import { factory } from '../positions/asset-position-details/asset-position-details-container';
import AssetPositionDetails from '../positions/asset-position-details/asset-position-details';

import CashChartHeader from './cash-chart-header';

export default factory({
  rowFragmentExtend: {
    balance: true,
    dayChange: true,
    dayChangePercentage: true,
    availableBalance: true,
  },

  mapperExtend: ({ availableBalance, currency, asOfDate }) => ({
    chartHeaderValue: availableBalance,
    balanceUnit: currency,
    priceDate: asOfDate,
  }),

  component: props =>
    <AssetPositionDetails {...props} chartHeaderComponent={CashChartHeader} />,
});
